import { render, staticRenderFns } from "./newyear.vue?vue&type=template&id=0ed8e4d5&scoped=true&"
import script from "./newyear.vue?vue&type=script&lang=js&"
export * from "./newyear.vue?vue&type=script&lang=js&"
import style0 from "./newyear.vue?vue&type=style&index=0&id=0ed8e4d5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed8e4d5",
  null
  
)

export default component.exports